// import { resolve } from 'path'
import {
  setToken
} from '@/utils/auth.js'
import {
  loginApi,
  getUserName,
  getMenus
} from '@/api/login'
import {
  getUserInfo
} from '@/api/identity'
import config from '@/utils/config'
const login = {
  state: {
    username: '',
    breadcrumblist: '', // 面包屑集合
    menuList: [],
    logo: '',
    client: null // 商户标识
  },
  mutations: {
    SET_USERNAME(state, val) {
      state.username = val
    },
    SET_BREADCRUMBLIST(state, val) {
      state.breadcrumblist = val
    },
    SET_MENULIST(state, val) {
      state.menuList = val
    },
    SET_LOGO(state, val) {
      state.logo = val
    },
    SET_CLIENT(state, val) {
      state.client = val
    }
  },
  actions: {
    getUserNameAsync({
      commit
    }, {
      username,
      password,
      sysId
    }) {
      return new Promise((resolve, reject) => {
        // 获取token
        loginApi(username, password, sysId).then(res => {
          if (res.success) {
            // 存储token
            setToken(res.data)
            // 获取用户信息 用户名等
            getUserName(res.data).then(res => {
              localStorage.setItem('username', res.data.username)
              localStorage.setItem('userId', res.data.id)
              localStorage.setItem('commLevel', res.data.commLevel)
              commit('SET_USERNAME', res.data.username)
              resolve(res)
            }).catch(err => {
              console.log(err)
              reject(err)
            })
          }
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    // 根据token获取用户详情。
    tokenTOusername({
      commit
    }, {
      token
    }) {
      return new Promise((resolve, reject) => {
        getUserName(token).then(res => {
          console.log(res,'res')
          localStorage.setItem('username', res.data.username)
          localStorage.setItem('userId', res.data.id)
          localStorage.setItem('userphone', res.data.phone)
          commit('SET_USERNAME', res.data.username)
          resolve(res)
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },



    // 获取菜单权限
    getmenusAsync({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getMenus(config.sysid).then(res => {
          if (res.success) {
            if (!res.data) res.data = []
            //根据用户手机号判断是否显示充值菜单

            if (localStorage.getItem('userphone') == '18053103586') {
              res.data.push({
                "id": 222309999,
                "createTime": "2019-02-19 15:09:06",
                "updateTime": "2019-02-19 15:10:07",
                "createBy": 1,
                "updateBy": 1,
                "createUser": "默认管理员",
                "updateUser": "默认管理员",
                "seq": 11,
                "pid": 0,
                "perm": "",
                "name": "充值",
                "icon": "icon-shuzihuadaping1",
                "url": "card",
                "subsysId": 56,
                "type": 0,
                "tips": "",
                "hidden": false,
                "status": 1,
                "children": [
                  {
                    "id": 222310,
                    "createTime": "2019-02-19 15:11:10",
                    "createBy": 1,
                    "createUser": "默认管理员",
                    "seq": 1,
                    "pid": 222309999,
                    "perm": "",
                    "name": "电子卡充值",
                    "icon": "",
                    "url": "cardManage",
                    "subsysId": 56,
                    "type": 1,
                    "tips": "",
                    "hidden": false,
                    "status": 1,
                    "children": [
                      {
                        "id": 222311999,
                        "createTime": "2019-02-19 15:16:22",
                        "updateTime": "2019-02-19 15:16:43",
                        "createBy": 1,
                        "updateBy": 1,
                        "createUser": "默认管理员",
                        "updateUser": "默认管理员",
                        "seq": 1,
                        "pid": 222310999,
                        "perm": "",
                        "name": "电子卡充值",
                        "icon": "",
                        "url": "index",
                        "subsysId": 56,
                        "type": 2,
                        "tips": "",
                        "hidden": false,
                        "status": 1,
                        "extra": "index"
                      }
                    ],
                    "extra": "cardManage"
                  }
                ],
              })
            }
            resolve(res.data)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取商户id
    getUserInfoApi() {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    async getmenu({
      dispatch,
      commit
    }) {
      let userinfo = await dispatch('getUserInfoApi')
      localStorage.setItem('commercialId', userinfo.id)

      localStorage.setItem('userName', userinfo.userName)
      let menulist = await dispatch('getmenusAsync')
      return menulist
    }
  }
}

export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js